<template>
    <v-row dense>
        <v-col v-for="stat in stats" :key="stat.label" cols="12" sm="6" md>
            <v-card class="stat-card pa-2 d-flex align-center" elevation="2">
                <v-avatar size="44" :color="stat.color" class="mr-4">
                    <v-icon color="white" size="22">{{ stat.icon }}</v-icon>
                </v-avatar>
                <div>
                    <div class="stat-label">{{ stat.label }}</div>
                    <div class="stat-value">{{ stat.value }}</div>
                    <div class="stat-subtitle">{{ subtitle }}</div>
                    <div class="stat-bar" :style="{ backgroundColor: stat.color }"></div>
                </div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'StatsCards',

    props: {
        stats: {
            type: Array,
            required: true,
            // [{ label: 'Available', value: 87, icon: 'mdi-train-variant', color: '#1FA055' }, …]
        },
        subtitle: {
            type: String,
            default: 'locomotives',
        },
    },
};
</script>

<style scoped>
.stat-card {
    border-radius: 8px !important;
    height: 100%;
}

.stat-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.6px;
    color: #8a94a6;
    text-transform: uppercase;
}

.stat-value {
    font-size: 26px;
    font-weight: 700;
    line-height: 1.2;
    color: #1a2b3c;
}

.stat-subtitle {
    font-size: 11px;
    color: #8a94a6;
}

.stat-bar {
    width: 26px;
    height: 3px;
    border-radius: 2px;
    margin-top: 6px;
}
</style>